/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_SavedInputs */

const en_existing_saved = /** @type {(inputs: Existing_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation saved`)
};

const id_existing_saved = /** @type {(inputs: Existing_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentasi tersimpan`)
};

/**
* | output |
* | --- |
* | "Documentation saved" |
*
* @param {Existing_SavedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_saved = /** @type {((inputs?: Existing_SavedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_SavedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_saved(inputs)
	return en_existing_saved(inputs)
});